import { axiosInstance } from "./axios"
import useCustomMutation from 'hooks/useCustomMutation';

const download = (payload: { id: string }) => {
    return axiosInstance.get(`/export/download?id=${payload.id}`);
}

const useDownload = () => {
    return useCustomMutation(download);
}

const prepareDownload = () => {
    return axiosInstance.get("/export/prepare");
}

const usePrepareDownload = () => {
    return useCustomMutation(prepareDownload)
}
export default {
    useDownload,
    usePrepareDownload

}